import { FileType } from 'further-ui/utils';

const downloadPdf = (file: string, fileName: string) => {
  const mediaType = `data:${FileType.PDF};base64,`;
  const aElement = document.createElement('a');
  aElement.setAttribute('download', fileName);
  aElement.href = `${mediaType}${file}`;
  aElement.setAttribute('target', '_blank');
  aElement.click();
};

export default downloadPdf;
